import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import * as contractGenerationActionTypes from "../../../../../features/document/edit/contractGeneration/actionTypes";
import initialState from "reducers/initialState";

const financedOffersReducer = (state = initialState.currentFolder.financedOffers, action) => {
  switch (action.type) {
    case actionTypes.LOAD_FINANCED_OFFERS_STARTED: {
      let result = { ...state, loading: true };
      return result;
    }
    case actionTypes.LOAD_FINANCED_OFFERS_SUCCEEDED: {
      let result = { ...state, ids: [...action.result], loading: false, isLoaded: true };
      return result;
    }

    case actionTypes.LOAD_FINANCED_OFFERS_FAILED: {
      let result = { ...state, loading: false };
      return result;
    }

    case eventTypes.FINANCED_OFFERS_INVALIDATED:
    case contractGenerationActionTypes.FOLDER_INVALIDATED: {
      const result = { ...state, loading: false, isLoaded: false, saving: false };
      return result;
    }
    default:
      return state;
  }
};

const folderOfferPartnersReducer = (state = initialState.currentFolder.offerPartners, action) => {
  switch (action.type) {
    case actionTypes.LOAD_FOLDER_OFFER_PARTNERS_STARTED: {
      const result = { ...state, loading: true };
      return result;
    }

    case actionTypes.LOAD_FOLDER_OFFER_PARTNERS_SUCCEEDED: {
      let result = { ...state, ids: [...action.result], loading: false, isLoaded: true };
      return result;
    }

    case actionTypes.LOAD_FINANCED_OFFERS_FAILED: {
      let result = { ...state, loading: false };
      return result;
    }

    default:
      return state;
  }
};

const clientOffersReducer = (state = initialState.currentFolder.clientOffers, action) => {
  switch (action.type) {
    case actionTypes.LOAD_CLIENT_OFFERS_STARTED: {
      const result = { ...state, loading: true };
      return result;
    }

    case actionTypes.LOAD_CLIENT_OFFERS_SUCCEEDED: {
      const result = { ...state, ids: [...action.result], loading: false, isLoaded: true };
      return result;
    }

    case actionTypes.LOAD_CLIENT_OFFERS_FAILED: {
      const result = { ...state, loading: false };
      return result;
    }

    case eventTypes.CLIENT_OFFERS_INVALIDATED: {
      const result = { ...state, loading: false, isLoaded: false, saving: false };
      return result;
    }

    default:
      return state;
  }
};

const exp = {
  financedOffersReducer,
  clientOffersReducer,
  folderOfferPartnersReducer
};
export default exp;
